import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "./ThemeProvider";
import { cn } from "@/lib/utils";

const ORDER = ["system", "light", "dark"] as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex items-center gap-0.5 rounded-full border border-border bg-card p-0.5"
    >
      {ORDER.map((t) => {
        const Icon = t === "light" ? Sun : t === "dark" ? Moon : Monitor;
        const active = theme === t;
        return (
          <button
            key={t}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setTheme(t)}
            className={cn(
              "flex h-7 w-7 items-center justify-center rounded-full text-muted-foreground transition-colors",
              active && "bg-primary text-primary-foreground shadow-beam-sm",
              !active && "hover:text-foreground",
            )}
            title={t}
          >
            <Icon size={14} />
          </button>
        );
      })}
    </div>
  );
}
